<template>
  <div class="svg-body">
    <div v-html="svgHtml"></div>
  </div>
</template>

<script>
import $ from 'jquery';
import svgPanZoom from '../utils/svg-pan-zoom';

export default {
  props: {
    svgHtml: {
      type: String,
      default: '',
    },
    types: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      svgBlockElement: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.svgBlockElement = $('.svg-block');
      setTimeout(() => {
        // this.initZoom();
        this.onClickBlock();
      }, 1000);
    },
    onClickBlock() {
      this.svgBlockElement.unbind('click');
      this.svgBlockElement.on('click', (event) => {
        const { id, dataset: { disabled } } = event.currentTarget;
        if (disabled) return;
        this.$emit('select', { id });
      });
    },
    initZoom() {
      svgPanZoom('#svgZoom');
    },
    disableBlocks() {
      $('.svg-block').attr('data-disabled', true);
      this.types.forEach((el) => {
        if (el.stock > 0) {
          $(`#${el.blockId}`).removeAttr('data-disabled');
        }
      });
    },
  },
};
</script>

<style lang="scss">
.svg-block{
  cursor: pointer;
  &[data-disabled] {
    cursor: default;
    > path:first-child,
    > rect {
      fill: #999;
    }
  }
  &[data-toggle] {
    opacity: 1 !important;
  }
}

.svg-body{
  height: 65vh;
  padding: 5px;
  background: #fff;
  // border: 1px solid #f0f0f0;
  box-shadow: inset 0 3px 5px rgba(#000, 0.1);
  svg{
    width: 100%;
    height: 64vh;
  }
}
</style>
